<template>
    <div :id="rootElementId" :style="`height:${height}px`" v-bind:class="{'d-flex justify-center':!embed}"></div>
</template>

<script>
import { getDataUrl } from "../../utils/functions";
export default {
  name: "DriblabSocialMedia",
  computed: {
    rootElementId() {
      return `driblabSocialMedia${this.id}`;
    },
    darkMode(){
      return this.$vuetify.theme.dark;
    }
  },
  props:{
    id:{
      required: true
    },
    height:{
      type:Number,
      default:100
    },
    width:{
      type: Number,
      default: 300
    },
    color:{
      type: String,
      default: "#6d7de5"
    },
    bgColor:{
      type: String,
      default: "white"
    },
    margin:{
      type: Object,
      required: false
    },
    title:{
      type: String,
      default: ""
    },
    subtitle:{
      type: String,
      default: ""
    },
    textColor:{
      type: String,
      default: ""
    },
    logoCfg:{
      type: String,
      default: ""
    },
    type:{
      type: String,
      default: "radar"
    },
    fontWeight:{
      type: String,
      default: "300"
    },
    fontSize:{
      type: String,
      default: "14"
    },
    sponsor:{
      type: String,
      required: false
    },
    embed:{
      type:Boolean,
      default:false
    },
    fontFamily:{
      type: String,
      default: 'NeueMontreal'
    }
  },
  data() {
    return {
      images:{}
    };
  },
  mounted: function() {
    window.addEventListener("resize", this.onWindowResize);
    this.printD3()
  },
  created() {},
  destroyed() {
    window.removeEventListener("resize", this.onWindowResize);
  },
  watch:{
    "width": function(newValue,oldValue){
      this.printD3();
    }
  },
  methods: {
    async printD3(force = false){
      if(force){
        this.images = {}
      }
      const scale = d3.scale.linear()
      .range([0.86, 0.92])
      .domain([650, 1000]);
      let SVG_WIDTH
      if(this.type === "radar" || this.type === "polar"){
        SVG_WIDTH = this.width * 0.85 > 350 ? this.width * scale(this.width) : 350;
      }else if(this.type === "lollipop"){
        SVG_WIDTH = this.width * 0.95;
      }else{
        SVG_WIDTH = this.width;
      }

      if(this.embed){
        SVG_WIDTH = this.width;
      }

      d3.select(`#${this.rootElementId}`).select("svg").remove();

      var svg = d3.select(`#${this.rootElementId}`).append("svg")
      .attr("width", SVG_WIDTH)
      .attr("height", this.height)
      .style("fill", this.darkMode ? "cfcfcf" : "black")
      .style("background", this.bgColor)
      .attr("class", "driblabSocialMedia")
      .attr("id",`${this.rootElementId}SVG`)

      //INI --- DRAW
      // const SPACING_OFFSET = this.$vuetify.breakpoint.xlOnly ? 10 : 8;
      const SPACING_OFFSET = this.width * 0.02;
      let FONT_SIZE = this.fontSize && !this.embed ? this.fontSize : this.width * 0.025;
      if(FONT_SIZE > 16){
        FONT_SIZE = 16
      }
      // const LOGO_SIZE = this.$vuetify.breakpoint.xlOnly ? this.width * 0.035 : this.width * 0.0275;
      const LOGO_SIZE = FONT_SIZE * 1.35;
      const LOGO_Y = this.height/2;
      const LOGO_X = this.width * 0.04;
      if(!this.sponsor){
        await this.drawImageBase64(svg,LOGO_X,LOGO_Y + (FONT_SIZE / 5),LOGO_SIZE,LOGO_SIZE,require("@/assets/img/black_x.png"),"","twitterImg1")
        let twitterText1 = this.drawText(svg, LOGO_X + (LOGO_SIZE/2) + 4,LOGO_Y ,this.textColor,FONT_SIZE,this.fontWeight,"@driblab","left");

        // let twitter2X = LOGO_X + twitterText1[0][0].getBoundingClientRect().width + (LOGO_SIZE * 1.75);
        // await this.drawImageBase64(svg,twitter2X,LOGO_Y + (FONT_SIZE / 5),LOGO_SIZE,LOGO_SIZE,require("@/assets/img/black_x.png"),"","twitterImg2");
        let twitterText2 = this.drawText(svg, LOGO_X + (LOGO_SIZE/2) + 4,LOGO_Y + (FONT_SIZE * 1.2),this.textColor,FONT_SIZE,this.fontWeight,"@DriblabES","left")

        let instaX = SPACING_OFFSET + twitterText2[0][0].getBoundingClientRect().width + (LOGO_SIZE * 3);
        await this.drawImageBase64(svg,instaX,LOGO_Y + (FONT_SIZE / 5),LOGO_SIZE,LOGO_SIZE,require("@/assets/img/insta.png"),"","instaImg");
        let instaText = this.drawText(svg, instaX + (LOGO_SIZE * 0.9) ,LOGO_Y + (FONT_SIZE / 2),this.textColor,FONT_SIZE,this.fontWeight,"@driblab_sports","left")

        // let faceX = instaX + instaText[0][0].getBoundingClientRect().width + (LOGO_SIZE * 1.5)
        // await this.drawImageBase64(svg,faceX,LOGO_Y + (FONT_SIZE / 5),LOGO_SIZE - 3,LOGO_SIZE - 3,require("@/assets/img/fb.png"),"","fbImg")
        // this.drawText(svg, faceX + (LOGO_SIZE/2) + 2,LOGO_Y + (FONT_SIZE / 2),this.textColor,FONT_SIZE,this.fontWeight,"/driblab","left")
      }else{
        const logoPoweredWidth = this.embed ? this.width * 0.15 : this.width * 0.15;;
        const logoPoweredHeight = this.embed ? this.height * 0.9 : this.height * 0.9;
        const imgLogoPowered = require("@/assets/img/logo_powered_horizontal.png");
        const lY = logoPoweredWidth > this.height ? LOGO_Y - (logoPoweredHeight * 0.01) : LOGO_Y;
        this.drawImageBase64(svg,logoPoweredWidth * 0.55,lY,logoPoweredWidth,logoPoweredHeight,imgLogoPowered,"",'LogoPowered')
      }

      if(this.type === "radar" || this.type === "polar" || this.type === "beeswarm" || this.type === "gameFlow" || this.type === "lollipop" || this.sponsor){
        const logoWidth = this.embed ? this.width * 0.15 : this.width * 0.15;
        const logoHeight = this.embed ? this.height * 0.9 : this.height * 0.9;
        const logoOffset = this.width * 0.02;
        const imgLogo = this.sponsor ? this.sponsor : require(this.logoCfg === 'white' ? "@/assets/img/driblab_normal_white.png" : "@/assets/img/driblab_normal_color.png");
        const lY = logoWidth > this.height ? LOGO_Y - (logoHeight * 0.01) : LOGO_Y;
        if(this.logoCfg != 'none'){
          this.drawImageBase64(svg,SVG_WIDTH - (logoWidth/2) - logoOffset,lY,logoWidth,logoHeight,imgLogo,"",this.sponsor ? 'SponsorLogo' : `DriblabLogo|${this.logoCfg}`)
        }
      }


      //END --- DRAW

    },
    async drawImageBase64(svg,x,y,width,height,img,className,idName,bottom = false,extraParams={}) {
      return new Promise((resolve) => {
        if(!this.images[idName]){
          let base_image = new Image();
          base_image.crossOrigin = "anonymous";
          base_image.src = img;
          base_image.onload = (event) => {
            const dataUrl = getDataUrl(event.currentTarget);
            this.drawImage(
            svg,
            x,
            y,
            width,
            height,
            dataUrl,
            className,
            idName,
            bottom,
            extraParams
            );
            resolve(true);
          }
        }else{
          if(bottom){
            svg.node().insertBefore(this.images[idName],svg.node().firstChild);
          }else{
            svg.node().appendChild(this.images[idName]);
          }
          resolve(true);
        }
      })
    },
    drawImage: function(svg, x, y, width, height, img,className,idName,bottom = false,extraParams={}) {
      let imgNode = bottom ? svg.insert("svg:image",":first-child") : svg.append("svg:image");
        imgNode.attr("x", x - (width / 2))
        .attr("y",  y - (height / 2))
        .attr("width", width)
        .attr("height", height)
        .attr("xlink:href", img)
        .attr("class",className)
        _.forEach(extraParams,(value,key) => {
          imgNode.attr(key,value);
        })
      this.images[idName] = imgNode.node().cloneNode(true);
    },
    drawRectangle(svg, x, y, width, height, color, opacity, className) {
      svg.append("rect")
        .attr("class", className)
        .attr("x", x)
        .attr("y", y)
        .attr("width", width)
        .attr("height", height)
        .style("fill", color)
        .style("opacity", opacity);
    },
    drawLine(svg, x, y, distance,size, color, opacity, className) {
      svg.append('line')
        .attr("class", className)
        .style("stroke", color)
        .style("stroke-width", size)
        .attr("x1", x - (distance/2))
        .attr("y1", y)
        .attr("x2", x + (distance/2))
        .attr("y2", y)
        .style("opacity", opacity);
    },
    drawCircle(svg, x, y, radius, fillColor,borderColor,borderSize, opacity, className) {
      return svg.append("circle")
        .attr("class", className)
        .attr("r", radius)
        .attr("cx", x)
        .attr("cy", y)
        .style("fill", fillColor)
        .style("stroke", borderColor)
        .style("stroke-width", borderSize)
        .style("opacity", opacity);
    },
    drawText(svg,x,y,color,fontSize,fontWeight,text,anchor="middle"){
      return svg.append("text")
      .attr("x",x)
      .attr("y",y)
      .attr("fill", color)
      .attr("font-size", fontSize)
      .attr("font-family", this.fontFamily)
      .attr("font-weight", fontWeight)
      .style("text-anchor",anchor)
      .text(text);
    },
    onWindowResize(){
      setTimeout(() => this.printD3(true),100);
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/base/DriblabSocialMedia.vue